const API_KEY ="a45c4e6dbd888d44b0893cb43f0855b3";
 const requests ={
    fetchTrending:         `/trending/all/week?api_key=${API_KEY}&language=en-US`, 
    fetchTopRated :        `/movie/top_rated?api_key=${API_KEY}&language=en`,
    fetchNeflixOriginals: `/discover/movie?api_key=${API_KEY}&with_genres=213`,
    fetchActionMovies:    `/discover/movie?api_key=${API_KEY}&with_genres=28`,
    fetchComedyMovies:    `/discover/movie?api_key=${API_KEY}&with_genres=35`,
    fetchHorrorMovies:    `/discover/movie?api_key=${API_KEY}&with_genres=27`,
    fetchRomanceMovies:   `/discover/movie?api_key=${API_KEY}&with_genres=10749`,
    fetchDocumentaries:   `/discover/movie?api_key=${API_KEY}&with_genres=99`,
    
}
export default requests;